<template>
    <div>
        <!-- Header -->
        <!-- Header -->
        <navbar></navbar>

        <!-- Page Hero -->
        <section class="page-hero d-flex align-items-center justify-content-center text-center text-white position-relative"
            style="background-color: #333; height: 300px; overflow: hidden;">
            <img src="https://placehold.co/1920x400/333333/666666?text=Payment+Hero"
                class="position-absolute w-100 h-100 object-fit-cover opacity-50" alt="Hero">
            <div class="position-relative z-1">
                <h1 class="display-4 fw-bold font-serif mb-2">Cart</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a href="/frontend"
                                class="text-white text-decoration-none small">Home</a></li>
                        <li class="breadcrumb-item active text-white-50 small" aria-current="page">Cart</li>
                    </ol>
                </nav>
            </div>
        </section>
        <div class="position-relative">
            <div class="torn-paper-edge"></div>
        </div>

        <!-- Main Content -->
        <section class="py-5 bg-light-creme">
            <div class="container mb-5">
                <!-- Stepper -->
                <div class="d-flex justify-content-center align-items-center mb-5 gap-3 stepper">
                    <div class="d-flex align-items-center gap-2 text-brown">
                        <div class="rounded-circle bg-light-brown text-brown d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;"><i class="bi bi-check fs-5"></i></div>
                        <span class="fw-bold">Cart</span>
                    </div>
                    <div class="bg-brown opacity-25" style="width: 100px; height: 1px;"></div>
                    <div class="d-flex align-items-center gap-2 text-brown">
                        <div class="rounded-circle bg-light-brown text-brown d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;"><i class="bi bi-check fs-5"></i></div>
                        <span class="fw-bold">Checkout</span>
                        <div class="bg-brown rounded-circle ms-2 p-1" style="width: 8px; height: 8px;"></div>
                    </div>
                    <div class="bg-brown opacity-25" style="width: 100px; height: 1px;"></div>
                    <div class="d-flex align-items-center gap-2 text-brown">
                        <div class="rounded-circle bg-brown text-white d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;">3</div>
                        <span class="fw-bold">Payment</span>
                    </div>
                </div>

                <div class="bg-white rounded-4 shadow-sm p-4 p-md-5">
                    <div class="row g-5">
                        <!-- Payment Methods Column -->
                        <div class="col-lg-7 border-end-lg">
                            <h5 class="fw-bold mb-4 font-serif">Payment Methods</h5>

                            <div class="mb-4">
                                <div class="form-check mb-3">
                                    <input class="form-check-input border-brown" type="radio" name="paymentMethod"
                                        id="payOnDelivery">
                                    <label class="form-check-label fw-bold small" for="payOnDelivery">
                                        Pay on Delivery
                                    </label>
                                    <div class="small text-muted ms-2">Pay with cash on delivery</div>
                                </div>

                                <div class="form-check mb-3">
                                    <input class="form-check-input border-brown" type="radio" name="paymentMethod"
                                        id="creditCard" checked>
                                    <label
                                        class="form-check-label fw-bold small d-flex justify-content-between align-items-center"
                                        for="creditCard">
                                        <span>Credit/Debit Cards</span>
                                        <div class="d-flex gap-1">
                                            <img src="https://placehold.co/30x20/transparent/333?text=V" alt="Visa">
                                            <img src="https://placehold.co/30x20/transparent/333?text=M" alt="Master">
                                        </div>
                                    </label>
                                    <div class="small text-muted ms-2 mb-3">Pay with your Credit / Debit Card</div>

                                    <!-- Credit Card Form -->
                                    <div class="ms-4 p-3 bg-light rounded-3">
                                        <div class="mb-3 position-relative">
                                            <input type="text" class="form-control rounded-3 ps-3"
                                                placeholder="Card number">
                                            <i
                                                class="bi bi-credit-card position-absolute top-50 end-0 translate-middle-y me-3 text-muted"></i>
                                        </div>
                                        <div class="row g-3">
                                            <div class="col-6">
                                                <div class="position-relative">
                                                    <input type="text" class="form-control rounded-3" placeholder="MM / YY">
                                                    <i
                                                        class="bi bi-calendar position-absolute top-50 end-0 translate-middle-y me-3 text-muted"></i>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="position-relative">
                                                    <input type="text" class="form-control rounded-3" placeholder="CVV">
                                                    <i
                                                        class="bi bi-lock position-absolute top-50 end-0 translate-middle-y me-3 text-muted"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-check mb-3">
                                    <input class="form-check-input border-brown" type="radio" name="paymentMethod"
                                        id="bankTransfer">
                                    <label class="form-check-label fw-bold small" for="bankTransfer">
                                        Direct Bank Transfer
                                    </label>
                                    <div class="small text-muted ms-2">Make payment directly through bank account.</div>
                                </div>

                                <div class="form-check mb-3">
                                    <input class="form-check-input border-brown" type="radio" name="paymentMethod"
                                        id="otherMethods">
                                    <label
                                        class="form-check-label fw-bold small d-flex justify-content-between align-items-center"
                                        for="otherMethods">
                                        <span>Other Payment Methods</span>
                                        <div class="d-flex gap-1">
                                            <img src="https://placehold.co/30x20/transparent/333?text=P" alt="Paypal">
                                            <img src="https://placehold.co/30x20/transparent/333?text=G" alt="Google">
                                        </div>
                                    </label>
                                    <div class="small text-muted ms-2">Make payment through Gpay, Paypal, Paytm etc</div>
                                </div>
                            </div>

                        </div>

                        <!-- Review Order Column -->
                        <div class="col-lg-5 ps-lg-5">
                            <h5 class="fw-bold mb-4 font-serif">Review your cart</h5>

                            <!-- Mini Cart Item 1 -->
                            <div class="d-flex gap-3 mb-3 border-bottom pb-3">
                                <div class="bg-light-creme p-2 rounded-3" style="width: 60px; height: 60px;">
                                    <img src="https://placehold.co/60x60/transparent/8D6E63?text=Sofa" class="img-fluid"
                                        alt="Product">
                                </div>
                                <div class="flex-grow-1">
                                    <h6 class="fw-bold fs-6 mb-1">DuoComfort Sofa Premium</h6>
                                    <p class="small text-muted mb-0">1x</p>
                                </div>
                                <div class="fw-bold small">EGP 20.00</div>
                            </div>
                            <!-- Mini Cart Item 2 -->
                            <div class="d-flex gap-3 mb-4 border-bottom pb-3">
                                <div class="bg-light-creme p-2 rounded-3" style="width: 60px; height: 60px;">
                                    <img src="https://placehold.co/60x60/transparent/8D6E63?text=Desk" class="img-fluid"
                                        alt="Product">
                                </div>
                                <div class="flex-grow-1">
                                    <h6 class="fw-bold fs-6 mb-1">IronOne Desk</h6>
                                    <p class="small text-muted mb-0">1x</p>
                                </div>
                                <div class="fw-bold small">EGP 25.00</div>
                            </div>

                            <!-- Discount Code -->
                            <div class="input-group mb-4">
                                <span class="input-group-text bg-white border-end-0"><i
                                        class="bi bi-ticket-perforated"></i></span>
                                <input type="text" class="form-control border-start-0 ps-0" placeholder="Discount code">
                                <button class="btn btn-link text-brown fw-bold text-decoration-none"
                                    type="button">Apply</button>
                            </div>

                            <!-- Totals -->
                            <div class="d-flex justify-content-between mb-2 small">
                                <span class="text-muted text-info">Subtotal</span>
                                <span class="fw-bold">EGP 45.00</span>
                            </div>
                            <div class="d-flex justify-content-between mb-2 small">
                                <span class="text-muted">Shipping</span>
                                <span class="fw-bold">EGP 5.00</span>
                            </div>
                            <div class="d-flex justify-content-between mb-4 small">
                                <span class="text-muted">Discount</span>
                                <span class="fw-bold">-EGP 10.00</span>
                            </div>

                            <div class="d-flex justify-content-between align-items-center mb-4">
                                <span class="fw-bold">Total</span>
                                <span class="fw-bold fs-5">EGP 40.00</span>
                            </div>

                            <button class="btn btn-brown w-100 py-2 rounded-1 mb-3">Pay Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Footer -->
        <footer class="bg-beigey py-5 mt-5">
            <div class="container text-center text-muted small">&copy; Copyright Tip Top 2025</div>
        </footer>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Payment Component mounted.')
        }
    }
</script>
